var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttributeText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25600_346648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.92969 1.85625C8.76445 1.4168 8.34258 1.125 7.875 1.125C7.40742 1.125 6.98555 1.4168 6.82031 1.85625L2.03203 14.625H1.125C0.502734 14.625 0 15.1277 0 15.75C0 16.3723 0.502734 16.875 1.125 16.875H4.5C5.12227 16.875 5.625 16.3723 5.625 15.75C5.625 15.1277 5.12227 14.625 4.5 14.625H4.43672L5.06953 12.9375H10.6805L11.3133 14.625H11.25C10.6277 14.625 10.125 15.1277 10.125 15.75C10.125 16.3723 10.6277 16.875 11.25 16.875H14.625C15.2473 16.875 15.75 16.3723 15.75 15.75C15.75 15.1277 15.2473 14.625 14.625 14.625H13.718L8.92969 1.85625ZM9.83672 10.6875H5.91328L7.875 5.45273L9.83672 10.6875Z",
    fill: "#626F86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25600_346648"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H15.75V18H0V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributeText);
export default __webpack_public_path__ + "static/media/attributeText.51f82e19a84c4786d019fe532b15acb8.svg";
export { ForwardRef as ReactComponent };